var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "avax_balance_table"
  }, [_c('v-simple-table', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn() {
        return [_c('thead', [_c('tr', {
          staticClass: "grid_headers"
        }, [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Type")]), _c('th', {
          staticClass: "text-right chain"
        }), _c('th', {
          staticClass: "text-right balance"
        }, [_vm._v("Amount")])])]), _c('tbody', _vm._l(_vm.balances, function (item, i) {
          return _c('tr', {
            key: i
          }, [_c('td', {
            staticClass: "text-left"
          }, [_vm._v(_vm._s(item.name))]), _c('td', {
            staticClass: "text-right chain"
          }, [_c('span', {
            staticClass: "chain_tag",
            style: {
              backgroundColor: _vm.background(item.chain)
            }
          }, [_vm._v(_vm._s(item.chain))])]), _c('td', {
            staticClass: "text-right balance"
          }, [_vm._v(" " + _vm._s(item.balance) + " "), _c('span', [_vm._v("AVAX")])])]);
        }), 0)];
      },
      proxy: true
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }